import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { DatevService } from '../services/DatevService';
import { IIdAndName } from '../../../../core/interfaces/IIdAndName';

export const datevAccountsResolver: ResolveFn<IIdAndName[]> = () => {
  return inject(DatevService).getDatevAccounts()
    .pipe(map(res => res.data));
};
